import { Section, SectionHeading } from "@/components/ui";

/** The big idea of the industry: a headline, three facts and four areas of work. */
export function IndustryIntro({ intro }) {
  return (
    <Section labelledBy="industry-intro-title" testId="industry-intro">
      <SectionHeading id="industry-intro-title" title={intro.title} intro={intro.lead} />

      <ul className="mt-8 grid gap-4 sm:mt-10 md:grid-cols-3 md:gap-5" data-testid="industry-stats">
        {intro.stats.map((stat) => (
          <li key={stat.big}>
            <article className="h-full rounded-3xl border border-brand-200 bg-brand-50 p-5 sm:p-6">
              <b className="block break-words font-heading text-4xl font-bold leading-none text-brand-600 sm:text-5xl">{stat.big}</b>
              <p className="mt-3 text-base text-ink/80">{stat.text}</p>
            </article>
          </li>
        ))}
      </ul>

      <ul className="mt-6 grid gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4" data-testid="industry-areas">
        {intro.areas.map((area, i) => (
          <li key={area.title}>
            <article className="flex h-full items-start gap-3 rounded-3xl border border-brand-200 bg-white p-4 sm:p-5">
              <span
                aria-hidden="true"
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-500 font-heading text-sm font-bold text-white"
              >
                {i + 1}
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold leading-tight">{area.title}</h3>
                <p className="mt-1 text-sm text-ink/70 sm:text-base">{area.text}</p>
              </div>
            </article>
          </li>
        ))}
      </ul>
    </Section>
  );
}
